import React from "react";
import { withRouter } from "react-router-dom";
// import Snackbar from "@material-ui/core/Snackbar";
// import MuiAlert from "@material-ui/lab/Alert";
// import { withStyles } from "@material-ui/core/styles";
// import ErrorBoundary from "../error_boundary/error_boundary";
// import Alert from '@mui/material/Alert';
import { withStyles } from "@mui/styles";
import label from '../../utils/constant/label';
import Snackbar from '@mui/material/Snackbar';
import Alert, { AlertProps } from '@mui/material/Alert';

const styles = (theme) => ({
  alertSuccess: {
    // color: "#2e7d32",
    color: "#1BC5BD",
    backgroundColor: "#FFFFFF",
    //border: "1px solid #2e7d32",
    border: "1px solid #C9F7F5",
    border: "1px solid rgba(27, 207, 180, 0.2)",
    color: "#1bcfb4",
    fontFamily: 'Noto Sans',
    boxShadow: "0px 3px 5px -1px rgb(27 207 180 / 20%)",
    // [theme.breakpoints.down(600)]: {
    //   marginBottom: "26%",
    // },
  },
  alertWarning: {
    //color: "#ff9800",
    color: "#FFA800 ",
    backgroundColor: "#FFFFFF",
    // border: "1px solid #ff9800",
    border: "1px solid #FFF4DE",
    // [theme.breakpoints.down(600)]: {
    //   marginBottom: "26%",
    // },
  },
  alertError: {
    //color: "#d32f2f",
    color: "#F64E60",
    backgroundColor: "#FFFFFF",
    // border: "1px solid #d32f2f",
    border: "1px solid #FFE2E5",
    // [theme.breakpoints.down(600)]: {
    //   marginBottom: "26%",
    // },
  },
});

function SnackAlert(props) {
  return <Alert elevation={6} variant="filled" {...props} />;
}
class CommonSnackbar extends React.Component {
  componentDidMount() {
    setTimeout(() => {
      if (this.props.onClose != undefined) {
        this.props.onClose();
      }
    }, this.props.timer == undefined ? 4000 : this.props.timer);
  }
  render() {

    const { classes } = this.props;
    return (
      //   <ErrorBoundary>
      // <Snackbar
      //   open={this.props.open}
      //   autoHideDuration={3000}
      //   onClose={this.props.onClose}
      // >
      //   <SnackAlert
      //     onClose={this.props.onClose}
      //     classes={{
      //       root:
      //         this.props.severity == "success"
      //           ? classes.alertSuccess
      //           : this.props.severity == "warning"
      //           ? classes.alertWarning
      //           : this.props.severity === "error"
      //           ? classes.alertError
      //           : "",
      //     }}
      //     severity={this.props.severity}
      //   >
      //     {this.props.message}
      //   </SnackAlert>
      // </Snackbar>


      <Snackbar open={this.props.open}
       autoHideDuration={this.props.timer == undefined ? 3000 : this.props.timer}
        onClose={this.props.onClose}
        anchorOrigin={{ vertical:"bottom", horizontal:"center" }}
        >
        <Alert onClose={this.props.onClose} classes={{
          root:
            this.props.severity == "success" ?
              classes.alertSuccess : this.props.severity == "warning" ?
                classes.alertWarning : this.props.severity === "error" ?
                  classes.alertError : ""
        }}
          severity={this.props.severity} >
          {this.props.message != undefined && this.props.message != "" ? this.props.message.toLowerCase() == "Something went wrong".toLowerCase() ? label.messages.apierror : this.props.message : "Failed"}
        </Alert>
      </Snackbar>


    );
  }
}

export default withStyles(styles)(withRouter(CommonSnackbar));
